var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-3 mb-12",attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.loading,"items-per-page":-1}})}
var staticRenderFns = []

export { render, staticRenderFns }